import axios from "axios";
import { getZipmapPlaceDetailsUrl, getZipmapUrl, getUserMapsUrl, getEditMapDescriptionUrl, getEditMapNameUrl, getEditMapSlugUrl, getPauseMapUrl, getStartMapUrl, getEditMapDefaultMarkerUrl, getUploadCoverPhotoUrl, getUploadLogoUrl, getUploadLogoDarkUrl, getEditMapDefaultViewToListUrl, getEditMapDefaultViewToMapUrl, getEditMapPlaceUrl, getAddMapPlaceUrl, getDeleteMapPlaceUrl, getUpdateMapPlacesSequenceUrl, getAddMapUrl, getDeleteMapUrl, getMapMembersUrl, getInviteMapMemberUrl, getEditMapIsSortAllowedUrl, getEditMapPrimaryColorUrl } from "./ServiceUrls";
import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default class ZipmapRepository {
    async getZipmapDetails(slug, sortType, coordinates) {
        const session = await supabase.auth.getSession()
        const headers = {}
        if (session.data.session) {
            headers['Authorization'] = `Bearer ${session.data.session.access_token}`
        }
        let response = await axios.get(
            getZipmapUrl(slug, sortType, coordinates),
            {
                headers: headers
            }
        );
        console.log(response.data)
        return response.data
    }

    async getZipmapPlaceDetails(placeId) {
        let response = await axios.get(
            getZipmapPlaceDetailsUrl(placeId)
        );
        console.log(response.data)
        return response.data
    }

    async getUserMaps() {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getUserMapsUrl(),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async addMap(mapName, mapSlug, mapDefaultMarker, mapDefaultView, coverPhoto, logoImage, description) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        if (coverPhoto) {
            formData.append(`cover`, coverPhoto.file)
        }
        if (logoImage) {
            formData.append(`logo`, logoImage.file)
        }
        formData.append(`name`, mapName)
        formData.append(`slug`, mapSlug)
        formData.append(`defaultMarker`, mapDefaultMarker)
        formData.append(`defaultView`, mapDefaultView)
        formData.append(`description`, description)
        const response = await axios.post(
            getAddMapUrl(mapSlug),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async deleteMap(mapSlug) {
        const session = await supabase.auth.getSession()
        await axios.delete(
            getDeleteMapUrl(mapSlug),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
    }
    
    async editMapDescription(mapSlug, description) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapDescriptionUrl(mapSlug),
            { description: description },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapName(mapSlug, name) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapNameUrl(mapSlug),
            { name: name },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapPrimaryColor(mapSlug, primaryColor) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapPrimaryColorUrl(mapSlug),
            { primaryColor: primaryColor },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapSlug(mapSlug, slug) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapSlugUrl(mapSlug),
            { slug: slug },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapDefaultMarker(mapSlug, marker) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapDefaultMarkerUrl(mapSlug),
            { defaultMarker: marker },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapDefaultViewToList(mapSlug) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapDefaultViewToListUrl(mapSlug),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapDefaultViewToMap(mapSlug) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getEditMapDefaultViewToMapUrl(mapSlug),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapLiveStatus(mapSlug, isLive) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            isLive ? getStartMapUrl(mapSlug) : getPauseMapUrl(mapSlug),
            {},
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        )
        return response.data
    }

    async editMapIsSortAllowed(mapSlug, isSortAllowed) {
        const session = await supabase.auth.getSession()
        if (isSortAllowed) {
            const response = await axios.post(
                getEditMapIsSortAllowedUrl(mapSlug),
                {},
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            )
            return response.data
        } else {
            const response = await axios.delete(
                getEditMapIsSortAllowedUrl(mapSlug),
                {
                    headers: {
                        'Authorization': `Bearer ${session.data.session.access_token}`
                    }
                }
            )
            return response.data
        }
    }

    async uploadCoverPhoto(mapSlug, image) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append(`image`, image)
        const response = await axios.post(
            getUploadCoverPhotoUrl(mapSlug),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async uploadLogoImage(mapSlug, image) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append(`image`, image)
        const response = await axios.post(
            getUploadLogoUrl(mapSlug),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }


    async uploadDarkLogoImage(mapSlug, image) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        formData.append(`image`, image)
        const response = await axios.post(
            getUploadLogoDarkUrl(mapSlug),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async editPlace(mapSlug, placeId, images, name, shortDescription, longDescription, coordinates, emoji, markerSpecialEffect) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        images.forEach((image) => {
            if (image.file) {
                formData.append(image.name, image.file)
            }
        });
        const imageSequence = images.map((image) => {
            if (image.file) {
                return {
                    url: image.name
                }
            } else {
                return {
                    url: image.url,
                }
            }
        });
        formData.append(`imageSequence`, JSON.stringify(imageSequence))
        formData.append(`name`, name)
        formData.append(`description`, shortDescription)
        formData.append(`longDescription`, longDescription)
        formData.append(`coordinates`, JSON.stringify(coordinates))
        formData.append(`markerEffectType`, markerSpecialEffect)
        if (emoji) {
            formData.append(`emoji`, emoji)
        }
        const response = await axios.post(
            getEditMapPlaceUrl(mapSlug, placeId),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async addPlace(mapSlug, images, name, shortDescription, longDescription, coordinates, emoji, markerSpecialEffect) {
        const session = await supabase.auth.getSession()
        const formData = new FormData()
        images.forEach((image) => {
            if (image.file) {
                formData.append(image.name, image.file)
            }
        });
        const imageSequence = images.map((image) => {
            if (image.file) {
                return {
                    url: image.name
                }
            } else {
                return {
                    url: image.url,
                }
            }
        });
        formData.append(`imageSequence`, JSON.stringify(imageSequence))
        formData.append(`name`, name)
        formData.append(`description`, shortDescription)
        formData.append(`longDescription`, longDescription)
        formData.append(`coordinates`, JSON.stringify(coordinates))
        formData.append(`markerEffectType`, markerSpecialEffect)
        if (emoji) {
            formData.append(`emoji`, emoji)
        }
        const response = await axios.post(
            getAddMapPlaceUrl(mapSlug),
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data
    }

    async deletePlace(mapSlug, placeId) {
        const session = await supabase.auth.getSession()
        const response = await axios.delete(
            getDeleteMapPlaceUrl(mapSlug, placeId),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async updateMapPlacesSequence(mapSlug, sequence) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getUpdateMapPlacesSequenceUrl(mapSlug),
            { sequence: sequence },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async getMapMembers(mapSlug) {
        const session = await supabase.auth.getSession()
        const response = await axios.get(
            getMapMembersUrl(mapSlug),
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }

    async inviteMapMember(mapSlug, email) {
        const session = await supabase.auth.getSession()
        const response = await axios.post(
            getInviteMapMemberUrl(mapSlug),
            { email: email },
            {
                headers: {
                    'Authorization': `Bearer ${session.data.session.access_token}`
                }
            }
        );
        return response.data
    }
}